import { map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { Field, FieldGroup } from '../_models';
import { AppState } from '../_reducers';
import { selectAllFieldGroups } from '../_selectors/fieldGroup.selectors';

@Injectable()
export class FieldGroupService implements OnDestroy {
  private apiBaseUrl = environment.apiBaseUrl;
  private fieldGroupsList: Observable<FieldGroup[]>;
  private subscriptions: Subscription = new Subscription();
  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.fieldGroupsList = this.store.pipe(select(selectAllFieldGroups));
  }

  getFromLocalStore(): Observable<FieldGroup[]> {
    return this.fieldGroupsList;
  }

  getFieldGroups(): Observable<FieldGroup[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/fieldGroups').pipe(
      map((response) => {
        if (response) {
          const fieldGroups = response;
          fieldGroups.push({
            id: null,
            colorR: 51,
            name: this.translate.instant('fieldlist.label_nogroup'),
            colorB: 51,
            colorG: 51,
          });
          return fieldGroups;
        }

        return [];
      })
    );
  }
  getFieldGroup(id: number): Observable<FieldGroup> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/fieldGroups/' + id)
      .pipe(map((response) => response));
  }
  saveFieldGroup(fieldGroupElement): Observable<FieldGroup> {
    const fieldGroup = { ...fieldGroupElement };

    delete fieldGroup.lastUpdated;
    delete fieldGroup.dateCreated;

    if (fieldGroup.fields) {
      const arr: Array<any> = [];
      fieldGroup.fields.forEach((element) => {
        const idfield: any = {
          id: element.id,
        };
        arr.push(idfield);
      });
      fieldGroup.fields = arr;
    }
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    fieldGroup.companyId = companySelected ? companySelected.id : null;

    if (fieldGroup.id) {
      return this.http
        .put<FieldGroup>(
          this.apiBaseUrl + 'api/private/v1/fieldGroups/' + fieldGroup.id,
          fieldGroup
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<FieldGroup>(this.apiBaseUrl + 'api/private/v1/fieldGroups/', fieldGroup)
        .pipe(map((response) => response));
    }
  }
  deleteFieldGroup(id: number): Observable<FieldGroup> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/fieldGroups/' + id).pipe(
      map(() => {
        return { id } as FieldGroup;
      })
    );
  }

  getFieldGroupAreaFromFields(fieldGroup: FieldGroup, fields: Field[]) {
    let Area = 0;

    try {
      fields.forEach((field) => {
        if ((field.group ? field.group.id : null) === (fieldGroup ? fieldGroup.id : null)) {
          Area += field.sizeUnit == 'ha' ? +field.size : +(field.size / 10000);
        }
      });
    } catch {
      Area = 0;
    }

    return Area;
  }

  getFieldGroupById(id: number) {
    let group: FieldGroup;

    this.fieldGroupsList.subscribe((groups) => {
      group = groups.find((f) => Number(f.id) === id);
    });

    return group;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
